import { gql } from '@apollo/client';

export const RECORD_LABEL_REPLACEMENT_PRINTING = gql`
    mutation RecordLabelReplacementPrinting(
        $orderId: Long!
        $warehouseId: Long
        $warehouseName: String
    ) {
        recordLabelReplacementPrinting(
            orderId: $orderId
            warehouseId: $warehouseId
            warehouseName: $warehouseName
        )
    }
`;

export interface RecordLabelReplacementPrintingVariables {
    orderId: number;
    warehouseId?: number;
    warehouseName?: string;
}

export interface RecordLabelReplacementPrintingResponse {
    recordLabelReplacementPrinting: boolean;
}
